RCDPW.module('RCDPW.validator.rules.myAccount.AppForm', {
    organizationName: {
        required: true,
        rangelength: [1, 64],
        noWhiteSpace: true
    },
    displayName: {
        required: true,
        rangelength: [1, 64],
        noWhiteSpace: true
    },
    summary: {
        required: true,
        rangelength: [1, 140],
        noWhiteSpace: true
    },
    appPlatform: 'required'
});
